module.exports = __webpack_public_path__ + "img/showResume.63215e6c.svg";